(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["project-q-hero"] && !Shopify.designMode) return;
  try {
    
  const initializeProjectQVideoHero = (root) => {
    if (!root || root.dataset.videoInitialized === 'true') return;
    root.dataset.videoInitialized = 'true';

    const videos = Array.from(root.querySelectorAll('video'));
    const toggle = root.querySelector('[data-video-toggle]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const setPausedState = (paused) => {
      if (!toggle) return;
      toggle.setAttribute('aria-pressed', paused ? 'true' : 'false');
      toggle.setAttribute('aria-label', paused ? '播放背景影片' : '暫停背景影片');
    };

    const pauseVideos = () => {
      videos.forEach((video) => video.pause());
      setPausedState(true);
    };

    const playVideos = () => {
      videos.forEach((video) => {
        const result = video.play();
        if (result && typeof result.catch === 'function') result.catch(() => setPausedState(true));
      });
      setPausedState(false);
    };

    if (reduceMotion.matches) pauseVideos();

    toggle?.addEventListener('click', () => {
      const isPaused = toggle.getAttribute('aria-pressed') === 'true';
      if (isPaused) playVideos();
      else pauseVideos();
    });

    reduceMotion.addEventListener?.('change', (event) => {
      if (event.matches) pauseVideos();
    });
  };

  document.querySelectorAll('[data-project-q-video-hero]').forEach(initializeProjectQVideoHero);

  document.addEventListener('shopify:section:load', (event) => {
    initializeProjectQVideoHero(event.target.querySelector('[data-project-q-video-hero]'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["project-q-main-product-v2"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-pqv2-pdp]').forEach((root)=>{if(root.dataset.pqv2Ready==='true')return;root.dataset.pqv2Ready='true';const track=root.querySelector('[data-pqv2-track]');const current=root.querySelector('[data-pqv2-current]');if(track&&current){const slides=[...track.children];let ticking=false;track.addEventListener('scroll',()=>{if(ticking)return;ticking=true;requestAnimationFrame(()=>{let index=0;let distance=Infinity;slides.forEach((slide,i)=>{const d=Math.abs(slide.offsetLeft-track.scrollLeft);if(d<distance){distance=d;index=i}});current.textContent=String(index+1);ticking=false})},{passive:true})}const dialog=root.querySelector('[data-pqv2-dialog]');const image=root.querySelector('[data-pqv2-image]');root.querySelectorAll('[data-pqv2-zoom]').forEach((button)=>button.addEventListener('click',()=>{if(!dialog||!image)return;image.src=button.dataset.src;image.classList.remove('is-zoomed');dialog.showModal()}));root.querySelector('[data-pqv2-close]')?.addEventListener('click',()=>dialog?.close());image?.addEventListener('click',()=>image.classList.toggle('is-zoomed'));const select=root.querySelector('[data-pqv2-variant]');const price=root.querySelector('[data-pqv2-price]');const add=root.querySelector('[data-pqv2-add]');const qty=root.querySelector('[data-pqv2-qty]');select?.addEventListener('change',()=>{const option=select.selectedOptions[0];if(price&&option?.dataset.price)price.textContent=option.dataset.price;const available=option?.dataset.available==='true';if(add){add.disabled=!available;add.textContent=available?root.dataset.addLabel:root.dataset.soldLabel}if(qty)qty.disabled=!available})});

  } catch(e) { console.error(e); }
})();
})();
